import React from 'react'
import PropTypes from 'prop-types'
import styles from './ErrorText.scss'
import { t } from '../../services/translationService'

export default function ErrorText({ children, id, transKey }) {
  // console.log({ transKey })

  return (
    <div id={id} className={styles.Error}>
      {transKey && t(transKey)}
      {!transKey && children}
    </div>
  )
}
ErrorText.propTypes = {
  children: PropTypes.any,
  id: PropTypes.string,
  transKey: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/ErrorText/ErrorText.js